const callRecursivelyOnProperties = (subtree, method, secondParam) => {
    const keys = Object.keys(subtree);
    keys.forEach((key) => {
        const property = subtree[key];
        if (property && typeof property === 'object') {
            if (property.length) {
                property.map((obj) => method(obj, secondParam));
            } else {
                method(property, secondParam);
            }
        }
    });
};

const replaceLabelsForMenu = (subtree, labelsBySlug) => {
    if (!subtree || !labelsBySlug) return;

    const trackedSlugs = Object.keys(labelsBySlug);
    if (trackedSlugs.includes(subtree.slug)) {
        subtree.label = labelsBySlug[subtree.slug];
    }
    callRecursivelyOnProperties(subtree, replaceLabelsForMenu, labelsBySlug);
};

const replaceLabelsForPage = (subtree, labelsById) => {
    if (!subtree || !labelsById) return;

    const trackedIds = Object.keys(labelsById);
    if (trackedIds.includes(subtree.id)) {
        subtree.label = labelsById[subtree.id];
    }
    callRecursivelyOnProperties(subtree, replaceLabelsForPage, labelsById);
};

export { replaceLabelsForMenu, replaceLabelsForPage };
